export default __webpack_public_path__ + "7879eba811974c7f9e3bfb545c9e32dc.png";